/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { Col, Row, Card, Image, Button, Container } from "react-bootstrap";
import { Card as CardStrap } from "reactstrap";
import Icon from "react-native-vector-icons/FontAwesome";
import { Link } from "react-router-dom";

const DEFAULT_IMAGE = require("./assets/404.svg");

export interface INotFoundPageProps {
    goBackToLink?: string;
    notFoundImage?: any;
    pageNotFoundRegularText?: string;
    pageNotFoundBoldText?: string;
    titleStyle?: any;
    descriptionStyle?: any;
    pageNotFoundDescription?: string;
    buttonText?: string;
    buttonStyle?: any;
}

export const NotFoundPage = ({
    goBackToLink,
    notFoundImage,
    pageNotFoundRegularText,
    pageNotFoundBoldText,
    pageNotFoundDescription,
    buttonText,
    titleStyle,
    descriptionStyle,
    buttonStyle,
}: INotFoundPageProps) => {
    return (
        <CardStrap className="py-4">
            <Row>
                <Col
                    xs={12}
                    className="text-center d-flex align-items-center justify-content-center"
                >
                    <div>
                        <Card.Link as={Link} to={goBackToLink}>
                            <Image
                                src={notFoundImage}
                                className="img-fluid w-75"
                            />
                        </Card.Link>
                        <h1 className="mt-5" style={titleStyle}>
                            {pageNotFoundRegularText}
                            <span className="fw-bolder">
                                {pageNotFoundBoldText}
                            </span>
                        </h1>
                        <p className="lead my-4" style={descriptionStyle}>
                            {pageNotFoundDescription}
                        </p>
                        <Button
                            as={Link}
                            variant="gray-800"
                            className="d-inline-flex align-items-center justify-content-center mb-4"
                            to={goBackToLink}
                            style={buttonStyle}
                        >
                            {/* <ChevronLeftIcon className="icon icon-xs me-2" /> */}
                            <Icon name="chevron-left" size={15} color="#fff" />
                            <span className="ms-2">{buttonText}</span>
                        </Button>
                    </div>
                </Col>
            </Row>
        </CardStrap>
    );
};

NotFoundPage.defaultProps = {
    goBackToLink: "/",
    notFoundImage: DEFAULT_IMAGE,
    pageNotFoundRegularText: "Page ",
    pageNotFoundBoldText: "not found",
    pageNotFoundDescription: "Oops! Looks like you followed a bad link.",
    buttonText: "Go Back to Home",
    buttonStyle: {
        backgroundColor: "#000",
        color: "#fff",
        fontWeight: "bold",
        borderRadius: "0.5rem",
        padding: "0.5rem 1rem",
        fontSize: "0.9rem",
    },
};
